import To from 'await-to-js'
import Callback from '@/services/Callback'
import qs from 'qs'
import { wizProtalInstance } from './instance'

export class PreferenceSettingApi {
  static async create(param) {
    const [err, res] = await To(
      wizProtalInstance.post('/api/cloud-render-management/preference-settings', param)
    )
    return Callback(err, res)
  }

  static async getCurrentUserSetting() {
    const [err, res] = await To(
      wizProtalInstance.get('/api/cloud-render-management/preference-settings/current-setting')
    )
    return Callback(err, res)
  }
}
export class FileApi {
  // 查询用户偏好设置
  static async getPublicImageBaseString(id) {
    const [err, res] = await To(
      wizProtalInstance.get(`/api/file-management/files/public/image/base64/${id}`)
    )
    return Callback(err, res)
  }
  // 保存偏好设置
  static async upload_0(param) {
    const [err, res] = await To(
      wizProtalInstance.post(
        `/api/file-management/files/upload?${qs.stringify(param.url)}`,
        param.body,
        {
          headers: {
            'Content-Type': 'multipart/form-data;',
          },
        }
      )
    )
    return Callback(err, res)
  }
}

export class ThreeDimensionalSectioningApi {
  // 查询用户偏好设置
  static async queryList(param) {
    const [err, res] = await To(
      wizProtalInstance.get(
        `/api/cloud-render-management/three-dimensional-sectionings/pageList?${qs.stringify(param)}`
      )
    )
    return Callback(err, res)
  }
  // 保存偏好设置
  static async create(param) {
    const [err, res] = await To(
      wizProtalInstance.post('/api/cloud-render-management/three-dimensional-sectionings', param)
    )
    return Callback(err, res)
  }
  // 保存偏好设置
  static async update(id, param) {
    const [err, res] = await To(
      wizProtalInstance.put(
        `/api/cloud-render-management/three-dimensional-sectionings/${id}`,
        param
      )
    )
    return Callback(err, res)
  }
  // 保存偏好设置
  static async callDelete_0(id, param) {
    const [err, res] = await To(
      wizProtalInstance.delete(
        `/api/cloud-render-management/three-dimensional-sectionings/${id}`,
        param
      )
    )
    return Callback(err, res)
  }
}
